import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Services from "../components/landing/Services";
import WhyUs from "../components/landing/WhyUs";
import TechStack from "../components/landing/TechStack";
import Process from "../components/landing/Process";
import Testimonials from "../components/landing/Testimonials";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="font-body text-gray-900 bg-[#FAFAFA] overflow-x-hidden">
      <Header />
      <Hero />
      <Services />
      <WhyUs />
      <TechStack />
      <Process />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
